/* global history */
import deviceMenu from '@js/common/deviceMenu.js';
import {
    initSVGBtns,
    headeraddClass,
} from '@js/common/customFunctions.js';
deviceMenu();

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    initSVGBtns();
    headeraddClass();
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {

    const mainHeader = $('header.main-header');

    // Handle scroll on page load with hash
    $(window).on('load', function() {
        if (window.location.hash) {
            const targetId = window.location.hash;
            const targetElement = $(targetId);

            if (targetElement.length) {
                setTimeout(() => {
                    $('html, body').stop().animate({
                        scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
                    }, 600);
                }, 200); // give time for layout render
            }
        }
    });

    // Handle click scroll (ONLY for same-page anchors)
    $(document).on('click', 'a[href^="#"]', function(e) {
        const targetId = $(this).attr('href');

        // Ignore empty or just "#"
        if (targetId === '#' || targetId.length < 2) {return;}

        const targetElement = $(targetId);

        if (targetElement.length) {
            e.preventDefault();

            $('html, body').stop().animate({
                scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
            }, 500);

            // Update URL without jump
            history.pushState(null, null, targetId);
        }
    });
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */